
  // A fake card form. The last digits of the number pick the outcome
  // (see Payments.Gateway.Dummy): 4111111111111111 approves,
  // 4000000000000002 declines, 4000000000000010 pends,
  // 4000000000000028 suspends, 4000000000000036 errors.
  const SUFFIX = {"0002": "-declined", "0010": "-pending", "0028": "-suspended", "0036": "-error"};
  export default {
    mounted() {
      const mount = this.el.querySelector(`#${this.el.id}-mount`);
      mount.innerHTML = `
        <label class="reg-label">Card number
          <input type="text" inputmode="numeric" autocomplete="cc-number" class="reg-input" data-role="number" value="4111111111111111">
        </label>
        <label class="reg-label">Expiry
          <input type="text" autocomplete="cc-exp" class="reg-input" data-role="expiry" value="12/30">
        </label>
        <label class="reg-label">Name on card
          <input type="text" autocomplete="cc-name" class="reg-input" data-role="name" value="Test Payer">
        </label>`;
      this.el.querySelector(`#${this.el.id}-pay`).addEventListener("click", () => {
        const digits = (mount.querySelector("[data-role=number]").value || "").replace(/\D/g, "");
        if (digits.length < 12) { this.fail("Enter a card number"); return; }
        const suffix = SUFFIX[digits.slice(-4)] || "";
        this.pushEvent("card_tokenised", {token: `dummy-${digits.slice(-4)}${suffix}`});
      });
    },
    fail(message) {
      this.pushEvent("card_frame_error", {message});
    }
  }
